import { render, staticRenderFns } from "./ModalNonActivePromotion.vue?vue&type=template&id=5a1eefc4&scoped=true&"
import script from "./ModalNonActivePromotion.vue?vue&type=script&lang=js&"
export * from "./ModalNonActivePromotion.vue?vue&type=script&lang=js&"
import style0 from "./ModalNonActivePromotion.vue?vue&type=style&index=0&id=5a1eefc4&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a1eefc4",
  null
  
)

export default component.exports